import { render, staticRenderFns } from "./ethics-first.vue?vue&type=template&id=3fe3c54b&"
import script from "./ethics-first.vue?vue&type=script&lang=js&"
export * from "./ethics-first.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fe3c54b')) {
      api.createRecord('3fe3c54b', component.options)
    } else {
      api.reload('3fe3c54b', component.options)
    }
    module.hot.accept("./ethics-first.vue?vue&type=template&id=3fe3c54b&", function () {
      api.rerender('3fe3c54b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/conversion-2023/ethics-first.vue"
export default component.exports